module.exports = __webpack_public_path__ + "img/gesture.f7487f7f.png";